import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useUser } from "../context/UserContext";
import axios from 'axios';
import config from '../config';
import LayoutBlank from '../layout/LayoutBlank';
import { toast } from 'react-toastify';

export default function VerifyEmail({ setCurrentPage }) {
    const { user, setUser, logoutUser } = useUser();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('verifying');

    useEffect(() => {
        const verifyEmail = async () => {
            const token = searchParams.get('token');
            // console.log(token);

            if (!token) {
                setStatus('error');
                toast.error('Invalid verification link, please request to resend link');

            } else {
                try {
                    const response = await axios.post(`${config.apiBaseUrl}/auth/verify-email?token=${token}`);
                    // console.log(response);                      
                    setUser((profile) => ({
                        ...profile,
                        email:  response?.data?.email,
                    }));
                    setStatus('success');
                    toast.success('Email verified, please login');

                } catch (err) {
                    setStatus('error');
                    toast.error('Verification failed, please request to resend link');
                }
            }

            setCurrentPage('login');
            setTimeout(() => navigate('/'), 3000);
        };

        logoutUser();
        verifyEmail();
    }, [searchParams, navigate]);

    return (
        <LayoutBlank>
            <div className="max-w-md mx-auto mt-8 p-6 bg-gray-800 rounded-lg shadow-md text-center">
                {status === 'verifying' && (
                    <div>
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-300 mx-auto mb-4"></div>
                        <p className="text-orange-300">Verifying your email ...</p>
                    </div>
                )}

                {status === 'success' && (
                    <div>
                        <h2 className="text-2xl font-bold text-orange-300 mb-2">Verification Succeeded</h2>
                        <p className="text-sm text-orange-200 mt-4">Redirecting to login ...</p>
                    </div>
                )}

                {status === 'error' && (
                    <div>
                        <h2 className="text-2xl font-bold text-orange-300 mb-2">Verification Failed</h2>
                        <p className="text-sm text-orange-200 mt-4">Redirecting to login ...</p>
                    </div>
                )}
            </div>
        </LayoutBlank>
    );
}

